import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import moment from 'moment';
import {
  iconsSet as icons
} from './assets/icons/icons.js'
import store from './store'
import VueToasted from 'vue-toasted';
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueToasted)
Vue.prototype.$log = console.log.bind(console)
Vue.use(wysiwyg, {
  image: {
    uploadURL: "/api/myEndpoint",
    dropzoneOptions: {}
  },
});

Vue.filter('thousandSeparator', function (amount) {
  if (!amount) {
    return 0;
  }
  if (
    amount !== "" ||
    amount !== undefined ||
    amount !== 0 ||
    amount !== "0" ||
    amount !== null
  ) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return amount;
  }
});

Vue.filter('thousandSeparatorStr', function (amount) {
  if (!amount) {
    return '0';
  }
  if (
    amount !== "" ||
    amount !== undefined ||
    amount !== 0 ||
    amount !== "0" ||
    amount !== null
  ) {
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return amount;
  }
});

Vue.filter('dateFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('DD MMM YYYY')
  }
  return moment(date).format('DD MMM YYYY')
});

Vue.filter('dateTimeFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('DD MMM YYYY HH:mm:ss')
  }
  return moment(date).format('DD MMM YYYY HH:mm:ss')
});

Vue.filter('timeFormat', function (date) {
  if (!date) {
    return '';
  }
  if (typeof date == 'object') {
    return date.format('HH:mm:ss')
  }
  return moment(date).format('HH:mm:ss')
});

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})